import { baseUrl, manifestUrl } from "./config/config";

export class Modal {
    constructor(...args: any) {
        fetch(`${manifestUrl}?t=${Date.now()}`, {
            headers: {
                'Cache-Control': 'no-cache'
            }
        })
        .then(res => res.json())
        .then(manifest => {
            if(!manifest['modal.js']) {
                console.error('manifest does not contain modal.js')
            }
            const acimaScript = document.createElement('script')
            acimaScript.src = `${baseUrl}/${manifest['modal.js']}`;
            document.head.appendChild(acimaScript)
            acimaScript.addEventListener('load', () => {
                new AcimaModal.Modal(...args)
            });
        })
        .catch(() => {
            console.error('could not get acima manifest')
        })
    }
}